import '../polyfills/url_can_parse.js';

import type { ContentType } from '../types.js';
import { getFileExtension } from './get_file_extension.js';

export function getContentTypeByUrl(url: string): ContentType {
  const fileExtension = getFileExtension(url);

  switch (fileExtension?.toLowerCase()) {
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'webp':
    case 'svg':
      return 'image';

    case 'mp4':
    case 'webm':
    case 'mov':
    case 'avi':
    case 'flv':
    case 'wmv':
    case 'mkv':
      return 'video';

    case 'mp3':
    case 'wav':
    case 'ogg':
    case 'flac':
    case 'aac':
      return 'audio';

    case 'pdf':
      return 'pdf';

    case 'glb':
    case 'gltf':
    case 'obj':
      return 'model';

    case 'm3u8':
    case 'mpd':
    case 'ts':
      return 'stream';

    default:
      return 'unknown';
  }
}
